<div class="empty-list">
  <h2>{{ 'search.map.empty.header' | translate }}</h2>
  <p>
    {{ 'search.map.empty' | translate }}
    <ng-container *ngIf="isMainApp">{{
      'search.map.missing' | translate
    }}</ng-container>
  </p>
  <button
    *ngIf="isMainApp"
    class="button button--primary button--large"
    (click)="sendMail()"
  >
    {{ 'search.map.empty.submit' | translate }}
  </button>
  <p
    *ngIf="showText"
    [innerHTML]="
      'search.map.empty.alternative' | translate : { recipient: emailRecipient }
    "
  ></p>
</div>
